// extracted by mini-css-extract-plugin
export var support = "Support-module--support--qxlWL";
export var inner = "Support-module--inner--hOxDv";